import {CompareBiomatchPayload, IdentityVerificationApi, IVPayload} from '../api';
import {FetcherSettings} from '../api/apiClient';

class IdentityVerificationService {
  private readonly identityVerificationApi: IdentityVerificationApi;

  constructor() {
    this.identityVerificationApi = new IdentityVerificationApi();
  }

  sendDocumentForFaceDetection(payload: IVPayload, resolverSettings?: FetcherSettings) {
    return this.identityVerificationApi.sendDocumentForFaceDetection(
      payload,
      resolverSettings,
    );
  }

  checkDocumentFaceDetectionStatus(id: string, resolverSettings?: FetcherSettings) {
    return this.identityVerificationApi.checkDocumentFaceDetectionStatus(
      id,
      resolverSettings,
    );
  }

  sendSelfieForFaceDetection(payload: IVPayload, resolverSettings?: FetcherSettings) {
    return this.identityVerificationApi.sendSelfieForFaceDetection(
      payload,
      resolverSettings,
    );
  }

  checkSelfieFaceDetection(id: string, resolverSettings?: FetcherSettings) {
    if (!id) throw new Error('The comparing id is missing');
    return this.identityVerificationApi.checkSelfieFaceDetection(id, resolverSettings);
  }

  compareSelfieAndDocumentFaces(
    payload: CompareBiomatchPayload,
    resolverSettings?: FetcherSettings,
  ) {
    return this.identityVerificationApi.compareSelfieAndDocumentFaces(
      payload,
      resolverSettings,
    );
  }

  checkSelfieAndDocumentFacesComparingStatus(
    id: string,
    resolverSettings?: FetcherSettings,
  ) {
    if (!id) throw new Error('The comparing id is missing');
    return this.identityVerificationApi.checkSelfieAndDocumentFacesComparingStatus(
      id,
      resolverSettings,
    );
  }

  sendImageForOCR(payload: IVPayload, resolverSettings?: FetcherSettings) {
    return this.identityVerificationApi.sendImageForOCR(payload, resolverSettings);
  }

  checkImageOCRStatus(id: string, resolverSettings?: FetcherSettings) {
    if (!id) throw new Error('The comparing id is missing');
    return this.identityVerificationApi.checkImageOCRStatus(id, resolverSettings);
  }
}

export {IdentityVerificationService};
